import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const currentDomain = this.getBaseDomain(window.location.hostname)

    this.element.querySelectorAll("a").forEach(link => {
      const linkDomain = this.getBaseDomain(new URL(link.href).hostname)

      if (linkDomain !== currentDomain) {
        link.target = "_blank"
        link.rel = "noopener noreferrer"
      }
    })
  }

  getBaseDomain(hostname) {
    return hostname.split(".").slice(-2).join(".")
  }
}
